import { useState, useContext, useEffect } from "react";
import styles from "../CreateProduct/CreateProductModal.module.css";
import { updateExpiredProduct } from "../../../hooks/ExpiredProduct";
import { ExpiredProductContext } from '../../../context/ExpiredProductContext';
import { TransformDateToBrazilianFormat } from '../../../utils/TransformDateToBrazilianFormat';
import { TransformDate } from '../../../utils/TransformDate';

function Modal({ closeModal }) {
  const { 
    editExpiredProduct, 
    selectedExpiredProduct
   } = useContext( ExpiredProductContext );
  
  const [productName, setProductName] = useState(selectedExpiredProduct[0]?.product.name || "");
  const [expirationDate, setExpirationDate] = useState(TransformDateToBrazilianFormat(selectedExpiredProduct[0]?.expirationDate) || "");
  const [lot, setLot] = useState(selectedExpiredProduct[0]?.lot || "");
  const [location, setLocation] = useState(selectedExpiredProduct[0]?.location || "");
  const [quantity, setQuantity] = useState(selectedExpiredProduct[0]?.quantity || "");
  const [quantitySold, setQuantitySold] = useState(selectedExpiredProduct[0]?.quantitySold || "");
  const [quantityLost, setQuantityLost] = useState(selectedExpiredProduct[0]?.quantityLost || "");
  const [balance, setBalance] = useState(selectedExpiredProduct[0]?.balance || "");

  useEffect(() => {
    const newBalance = (parseInt(quantity) || 0) - (parseInt(quantitySold) || 0) - (parseInt(quantityLost) || 0);
    setBalance(newBalance);
  }, [quantity, quantitySold, quantityLost]);

  const onEditClick = async (e) => {
    const expiredProductData = {
      id : selectedExpiredProduct[0]?.id,
      productId : selectedExpiredProduct[0]?.productId || 0,
      userId : selectedExpiredProduct[0]?.userId || 0,
      storeId : selectedExpiredProduct[0]?.storeId || 0, 
      quantity: parseInt(quantity), 
      quantitySold : parseInt(quantitySold),
      quantityLost : parseInt(quantityLost),
      balance : parseInt(balance),
      expirationDate : TransformDate(expirationDate),
      lot : lot,
      location : location,
  };
    const response = await updateExpiredProduct( expiredProductData );
    if (response) { 
      editExpiredProduct(true);
      closeModal();
    } else {
      editExpiredProduct(false);
      closeModal();
    }
  };

  const handleDateChange = (e) => {
    let input = e.target.value;
    input = input.replace(/\D/g, "");
    if (input.length >= 3 && input.length <= 4) {
      input = input.replace(/^(\d{2})(\d)/, "$1/$2");
    }
    if (input.length >= 5) {
      input = input.replace(/^(\d{2})\/?(\d{2})(\d+)/, "$1/$2/$3");
    }
    if (input.length > 10) {
      input = input.substring(0, 10);
    }
    setExpirationDate(input);
  };

  const isFormValid =
    productName.trim() !== "" &&
    lot.trim() !== "" &&
    expirationDate.trim() !== "" &&
    !isNaN(quantity) && quantity > 0 &&
    !isNaN(quantitySold) && quantitySold >= 0 &&
    !isNaN(balance) && balance >= 0;

  return (
    <div className={styles.modalBackground}>
      <div className={styles.modalContainer}>
        <div className={styles.content}>
          <form>

          <label>
              <span>Nome do Produto</span>
              <input
                type="text"
                required
                value={ productName }
                onChange={(e) => setProductName(e.target.value)}
                disabled = { true }
              />
            </label>

            <label>
              <span>Quantidade</span>
              <input
                type="text"
                required
                placeholder="Digite a quantidade do produto"
                value={ quantity }
                onChange={(e) => setQuantity(e.target.value)}
              />
            </label>

            
            <label>
              <span>Vendido</span>
              <input
                type="text"
                required
                placeholder="Digite a quantidade vendida"
                value={ quantitySold }
                onChange={ (e) => setQuantitySold(e.target.value)}
                maxLength="18"
              />
            </label>

            <label>
              <span>Perdido</span>
              <input
                type="text"
                required
                placeholder="Digite a quantidade perdida"
                value={ quantityLost }
                onChange={ (e) => setQuantityLost(e.target.value)}
                maxLength="18"
              />
            </label>


            <label>
              <span>Saldo</span>
              <input
                type="text"
                required
                placeholder="Saldo"
                value={ balance }
                onChange={(e) => setBalance(e.target.value)}
              />
            </label>

            <label>
              <span>Lote</span>
              <input
                type="text"
                required
                placeholder="Digite o lot do produto"
                value={ lot }
                onChange={(e) => setLot(e.target.value)}
              />
            </label>

            <label>
              <span>Data de validade</span>
              <input
                type="text"
                required
                placeholder="Digite a data de validade"
                value={expirationDate}
                onChange={handleDateChange}
              />
            </label>

            <label>
              <span>Localização</span>
              <input
                type="text"
                required
                placeholder="Digite a localização"
                value={ location }
                onChange={(e) => setLocation(e.target.value)}
              />
            </label>
          </form>
        </div>
        <div className={styles.buttonContent}>
          <button 
            onClick={ () => onEditClick() } 
            className={styles.buttonConfirm}
            disabled={!isFormValid}>
            Editar Produto
          </button>
          <button onClick={ closeModal } className={styles.buttonCancel}>Cancelar</button>
        </div>
      </div>
    </div>
  );
}

export default Modal;
